import { SupervisorEnrollmentInput } from '../../lib/types/models/trip-folder/enrollment-supervisor-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

type Input = SupervisorEnrollmentInput & {
  tripFolderId: number
  enrollmentId: number
}

export function unassignSupervisorFromEnrollment(input: Input) {
  const { tripFolderId, enrollmentId, ...rest } = input

  return restApiClient
    .url(
      constructApiUrl(API.tripFolder.unassignSupervisor.url, { id: tripFolderId, enrollmentId })
    )
    .post(rest)
}
